import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next';

i18n
  .use(reactI18nextModule)
  .init({
    debug: true,
    lng: 'de-DE',
    resources: {
      'de-DE': {
        'translation': {
          'employeeAppraisal': 'Mitarbeitergespräch',
          'errorBoundary': {
            'title': 'Ein unerwateter Fehler ist aufgetreten',
            'body': 'Sie können versuchen, neu zu laden um zu sehen, ob das Problem dadurch behoben wird.'
          },
          'menu': {
            'assessment': {
              'self': 'Selbsteinschätzung',
              'external': 'Fremdeinschätzung',
              'actual': 'Aktuell',
              'history': 'Historie'
            },
            'admin': 'Administration',
            'employees': 'Mitarbeiter',
            'questionnaire': 'Mitarbeitergespräche',
            'questionCatalogue': 'Fragenkatalog',
            'evaluation': 'Auswertung',
            'logout': 'Logout',
          },
          'answeredComponent': {
            'columnTitles': {
              'employee': 'Mitarbeiter',
              'answer':'Antwort',
            }
          },
          'employeeMultiSelect': {
            'noOptions': 'Keine Mitarbeiter gefunden',
            'placeholder': 'Keine Beurteiler ausgewählt',
            'label': 'Beurteiler',
          },
          'employeeSingleSelect': {
            'noOptions': 'Keine Mitarbeiter gefunden',
            'placeholder': 'Kein Beurteilter ausgewählt',
            'label': 'Beurteilter',
          },
          'catalogueSingleSelect': {
            'noOptions': 'Keine Fragenkataloge gefunden',
            'placeholder': 'Kein Fragenkatalog ausgewählt',
            'label': 'Fragenkatalog',
          },
          'customDatePicker': {
            'invalidDate': 'Ungültiges Datum',
            'minDateMsg': 'Das Datum muss nach dem {{minDate}} liegen',
            'maxDateMsg': 'Das Datum muss vor dem {{maxDate}} liegen'
          },
          'questionnaireComponent': {
            'anonymous': 'Dieses Mitarbeitergespräch ist anonym, das heißt die Beurteilte Person kann nicht erkennen wer welche Antworten gegeben hat.'
          },
          'questionCatalogueComponent': {
            'title': 'Vielen Dank für die Teilnahme',
            'body': 'Die Antworten können noch bis zum {{date}} bearbeitet werden.'
          },
          'answeredQuestionCatalogueComponent': {
            'title': 'Vielen Dank für die Teilnahme',
            'body': 'Hier können Sie Ihre vergangenen Mitarbeitergespräche jederzeit einsehen.'
          },
          'newEmployeeDialog': {
            'title': 'Neuer Mitarbeiter'
          },
          'editEmployeeDialog': {
            'title': 'Mitarbeiter bearbeiten'
          },
          'newQuestionnaireDialog': {
            'title': 'Neues Mitarbeitergespräch'
          },
          'editQuestionnaireDialog': {
            'title': 'Mitarbeitergespräch bearbeiten'
          },
          'newChoiceDialog': {
            'title': 'Neue Auswahlmöglichkeit'
          },
          'newColumnDialog': {
            'title': 'Neue Spalte'
          },
          'answerComponent': {
            'answer': 'Antwort',
            'comment': 'Kommentar'
          },
          'actualComponent': {
            'self': {
              'title': 'Momentan ist keine Selbsteinschätzung vorhanden'
            },
            'external': {
              'title': 'Momentan ist keine Fremdeinschätzung vorhanden'
            },
            'body': 'Bei Fragen wenden Sie sich bitte an HR.'
          },
          'historyComponent': {
            'self': {
              'title': 'Bisher hatten Sie noch kein Mitarbeitergespräch'
            },
            'external': {
              'title': 'Sie haben bisher noch keinen Mitarbeiter bewertet'
            },
          },
          'questionTab': {
            'saved': 'Frage wurde erfolgreich gespeichert'
          },
          'clusterTab': {
            'saved': 'Fragencluster wurde erfolgreich gespeichert'
          },
          'moduleTab': {
            'saved': 'Modul wurde erfolgreich gespeichert'
          },
          'catalogueTab': {
            'saved': 'Fragenkatalog wurde erfolgreich gespeichert'
          },
          'createCatalogueComponent': {
            'noModuleTitle': 'Modul ohne Titel',
            'noClusterTitle': 'Fragencluster ohne Titel',
            'noQuestion': 'Frage ohne Titel',
            'noModulesSelected': 'Keine Module gewählt',
            'noClusterSelected': 'Keine Fragencluster gewählt',
            'noQuestionsSelected': 'Keine Fragen gewählt',
            'noChoiceSelected': 'Keine Auswahlmöglichkeiten gewählt',
            'noColumnsSelected': 'Keine Spalten gewählt',
          },
          'noSearchResult' : {
            'title': 'Keine Suchergebnisse für "{{searchText}}"',
          },
          'noEntry' : {
            'evaluation' : {
              'title': 'Es sind noch keine Auswertungen vorhanden.',
            },
            'employees' : {
              'title': 'Es sind noch keine Mitarbeiter vorhanden.',
            },
            'questionCatalogue' : {
              'title': 'Es sind noch keine Fragenkataloge vorhanden.',
            },
            'createCatalogue' : {
              'title': 'Es sind noch keine Module vorhanden.',
            },
            'questionCluster' : {
              'title': 'Es sind noch keine Fragencluster vorhanden.',
            },
            'questionnaire' : {
              'title': 'Es sind keine aktiven Mitarbeitergespräche vorhanden.',
            },

          },
          'actions': {
            'start': 'Start',
            'reload': 'Neuladen',
            'add': 'Hinzufügen',
            'ok': 'OK',
            'save': 'Speichern',
            'cancel': 'Abbrechen',
            'next': 'Weiter',
            'back': 'Zurück',
            'finish': 'Fertig',
            'search': 'Suche',
            'download': 'Download',
            'edit': 'Bearbeiten'
          },
          'errors': {
            'unknownUser': {
              'headline': 'Unbekannter Benutzer',
              'body': 'Sie haben noch keinen Benutzer, wenden Sie sich bitte an HR'
            },
            'session_expired': 'Ihre Session ist abglaufen, Sie werden ausgelogged.',
            'forbiddenPage': {
              'button': 'Zur Startseite',
              'headline': 'Zugriff verweigert',
              'content': 'Sie haben nicht genügend Rechte für diese Seite',
            },
            'notFoundPage': {
              'button': 'Zur Startseite',
              'headline': 'Uups leider ist etwas schief gelaufen',
              'content': 'Die gewünschte Seite konnte nicht gefunden werden',
            }
          },
          'paginationNavigation': {
            'first': 'Erste Seite',
            'next': 'Nächste Seite',
            'previous': 'Vorherige Seite',
            'last': 'Letzte Seite',
            'page': 'Seite {{actual}} von {{complete}}'

          },
          'employee': {
            'firstName': 'Vorname',
            'lastName': 'Nachname',
            'email': 'E-Mail-Adresse',
            'roles': 'Rollen'
          },
          'userRoles': {
            'ADMIN': 'Administrator',
            'MAINTAINER': 'Bearbeiter',
            'USER':'Mitarbeiter',
          },
          'questionnaire': {
            'title': 'Titel',
            'description': 'Beschreibung',
            'appraisee': 'Beurteilter',
            'appraisers': 'Beurteiler',
            'anonymous': 'Anonym',
            'startDate': 'Startdatum',
            'endDate': 'Enddatum',
            'questionCatalogue': 'Fragenkatalog'
          },
          'catalogue': {
            'this': 'Fragenkatalog',
            'title': 'Titel',
            'modules': 'Module',
          },
          'module': {
            'this': 'Modul',
            'title': 'Titel',
            'description': 'Beschreibung',
            'cluster': 'Fragencluster'
          },
          'cluster': {
            'this': 'Fragencluster',
            'title': 'Titel',
            'description': 'Beschreibung',
            'question': 'Fragen',
          },
          'question': {
            'this': 'Frage',
            'description': 'Beschreibung',
            'choice': 'Auswahlmöglichkeiten',
            'column': 'Spalten',
            'comment': 'Kommentierbar',
            'questionTypes' : {
              'this': 'Fragentyp',
              'TEXT': 'Textfrage',
              'MULTIPLE_COLUMNS': 'Spalten-Frage',
              'MULTIPLE_CHOICE': 'Multiple Choice Frage'
            }
          },
          'comment': {
            'comment': 'Kommentar'
          },
          'choice': {
            'description': 'Beschreibung',
          },
          'column': {
            'title': 'Titel',
          },
          'validationErrors': {
            'Conflict': {
              'startDate': 'Das Startdatum darf nicht nach dem Enddatum liegen',
              'endDate': 'Das Enddatum darf nicht vor dem Startdatum liegen',
              'appraisers': 'Der Beurteiler darf sich nicht selbst beurteilen',
              'questionTypeText':'Der Fragentyp muss Textfrage sein',
              'questionTypeMultipleChoice':'Der Fragentyp muss Multiple Choice sein',
              'questionTypeMultipleColumn':'Der Fragentyp muss Spalten-Frage sein',
            },
            'Invalid': {
              'choices': 'Es dürfen keine Auswahlsmöglichkeiten angegeben sein',
              'columns': 'Es dürfen keine Spalten angegeben sein',
            },
            'FutureOrPresent': {
              'startDate': 'Das Startdatum darf nicht in der Vergangenheit liegen',
              'endDate': 'Das Enddatum darf nicht in der Vergangenheit liegen'
            },
            'NotEmpty': {
              'firstName': 'Der Vorname darf nicht leer sein',
              'lastName': 'Der Nachname darf nicht leer sein',
              'email': 'Die E-Mail-Adresse darf nicht leer sein',
              'title': 'Der Titel darf nicht leer sein',
              'question': 'Die Frage darf nicht leer sein',
              'startDate': 'Das Startdatum darf nicht leer sein',
              'endDate': 'Das Enddatum darf nicht leer sein',
              'appraisee': 'Der Beurteilter darf nicht leer sein',
              'appraisers': 'Die Beurteiler dürfen nicht leer sein',
              'catalogue': 'Der Fragenbogen darf nicht leer sein',
              'module': 'Es muss mindestens ein Modul hinzugefügt werden',
              'cluster': 'Es muss mindestens ein Fragencluster hinzugefügt werden',
              'questions': 'Es muss mindestens eine Frage hinzugefügt werden',
              'description': 'Die Beschreibung darf nicht leer sein',
              'choices': 'Es müssen mindestens zwei Möglichkeiten hinzugefügt werden',
              'columns': 'Es müssen mindestens zwei Spalten hinzugefügt werden',
            },
            'Email': {
              'email': 'Die E-Mail-Adresse ist ungültig',
            }
          }
        }
      }
    },
    react: {
      wait: false,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default'
    }
  });

export const translation = i18n;
